import {Stack, Text} from "@mantine/core";
import {ParsedLocation} from "../../types/general.types.ts";


export const LocationDetails = ({location}: {location: ParsedLocation}) => {

  const isDeepSpace = location?.system?.name.startsWith('Deep Space');

  return (
    <Stack gap={2}>
      {location?.container?.name ? <Text size="sm"><b>Container:</b> {location.container.name} <Text span c="dimmed">({location.container.type})</Text></Text> : null}
      {location?.sector?.name ? <Text size="sm"><b>Sector:</b> {location.sector.name}</Text> : null}
      {location?.system?.name ? <Text size="sm"><b>System:</b> {location.system.name} {!isDeepSpace ? <>({location.coordinates.galaxy.x}, {location.coordinates.galaxy.y})</> : null}</Text> : null}
      {location?.planet?.name ? <Text size="sm"><b>Planet:</b> {location.planet.name} ({location.coordinates.system.x}, {location.coordinates.system.y})</Text> : <Text size="sm"><b>System Location:</b> ({location.coordinates.system.x}, {location.coordinates.system.y})</Text>}
      {location?.city?.name ? <Text size="sm"><b>City:</b> {location.city.name} ({location.coordinates.surface?.x}, {location.coordinates.surface?.y})</Text> : null}
      {location?.coordinates?.ground ? (
        <Text size="sm"><b>Ground:</b> ({location.coordinates.ground.x}, {location.coordinates.ground.y})</Text>
      ) : null}
    </Stack>
  )
}
